import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("bdo_access");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

let refreshing = null;

client.interceptors.response.use(
    (r) => r,
    async (err) => {
        const original = err.config || {};
        const status = err.response?.status;
        if (status !== 401 || original._retry) return Promise.reject(err);
        const rt = localStorage.getItem("bdo_refresh");
        if (!rt) return Promise.reject(err);
        original._retry = true;
        try {
            if (!refreshing) {
                refreshing = axios.post(`${API}/auth/refresh`, { refresh_token: rt });
            }
            const { data } = await refreshing;
            refreshing = null;
            localStorage.setItem("bdo_access", data.access_token);
            localStorage.setItem("bdo_refresh", data.refresh_token);
            original.headers.Authorization = `Bearer ${data.access_token}`;
            return client(original);
        } catch (e) {
            refreshing = null;
            localStorage.removeItem("bdo_access");
            localStorage.removeItem("bdo_refresh");
            return Promise.reject(e);
        }
    }
);

export default client;
